import React, { Component } from "react";
import "./index.css";
import { getCrewStats } from "../../../../api-requests/candidate";
import { getJobStats } from "../../../../api-requests/job";

const StatRow = ({ label, value }) => (
    <div className="stat-row">
        <span className="stat-row-label">{label}</span>
        <span className="stat-row-value">{value ?? "—"}</span>
    </div>
);

class Stats extends Component {

    constructor(props) {
        super(props);
        this.state = { crew: {}, jobs: {} };
    }

    componentDidMount() {
        return getCrewStats().then(crew => {
            return getJobStats().then(jobs => this.setState({ crew, jobs }));
        });
    }

    render() {

        const { crew, jobs } = this.state;

        return(
            <div className="admin-page">
                <header className="admin-page-header">
                    <div className="admin-page-header-titles">
                        <h1 className="admin-page-title">Stats</h1>
                        <p className="admin-page-subtitle">A snapshot of crew and job activity.</p>
                    </div>
                </header>

                <div className="stats-grid">
                    <section className="stats-card">
                        <h2 className="stats-card-title">Crew</h2>
                        <div className="stats-card-list">
                            <StatRow label="Total crew" value={crew.total} />
                            <StatRow label="New this month" value={crew.thisMonth} />
                            <StatRow label="New this week" value={crew.thisWeek} />
                            <StatRow label="Active this month" value={crew.activeUsers} />
                            <StatRow label="Incomplete profiles" value={crew.incomplete} />
                            <StatRow label="Engineers" value={crew.engineers} />
                            <StatRow label="Deck" value={crew.decks} />
                            <StatRow label="Interior" value={crew.stews} />
                        </div>
                    </section>

                    <section className="stats-card">
                        <h2 className="stats-card-title">Jobs</h2>
                        <div className="stats-card-list">
                            <StatRow label="Total jobs" value={jobs.total} />
                            <StatRow label="This year" value={jobs.thisYear} />
                            <StatRow label="This month" value={jobs.thisMonth} />
                            <StatRow label="This week" value={jobs.thisWeek} />
                            <StatRow label="Today" value={jobs.today} />
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

export default Stats;
